import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceApi } from '../../../../../api/genericApi/service-api';
import { ConfigService } from '../../../../../Core/Config/services/config.service';
import { HttpVerbsEnum } from '../../../../../api/shared/enums/http-verbs.enum';
import { environment } from '../../../../../../environments/environment';

@Injectable()
export class HttpWrapperService {
    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService
    ) {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
    }

    public get<T>(url: string, query: object = {}): Observable<T> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.api<T>(url, null, HttpVerbsEnum.GET, query);
    }

    public delete<T>(url: string, query: object = {}): Observable<T> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.api<T>(url, null, HttpVerbsEnum.DELETE, query);
    }

    public post<T>(url: string, data: object): Observable<T> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.api<T>(url, data, HttpVerbsEnum.POST, null);
    }

    public newsroomPost<T>(url: string, data: object, httpParams: object): Observable<T> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.api<T>(url, data, HttpVerbsEnum.POST, httpParams);
    }

    public newsroomGet<T>(url: string, httpParams: object): Observable<T> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.api<T>(url, null, HttpVerbsEnum.GET, httpParams);
    }

    public newsroomGetImage<T>(url: string): Observable<Blob> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.getImageApi(this.serviceApi.apiUrl + url);
    }

    public agilityEmailDistGetImage<T>(url: string): Observable<Blob> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.getImageApi(url);
    }
}
